import { useState } from "react";
import TanstackTableComponents from "../../../components/tabel";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";

const History = () => {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [tabelCounts, setTabelCounts] = useState({
    totalItems: 0,
    totalPages: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);

  return (
    <DashboardLayout>
      <TanstackTableComponents
        rows={[]}
        columns={[]}
        pageCount={tabelCounts.totalPages}
        recordCount={tabelCounts.totalItems}
        heading="History"
        isLoading={tableLoading} // loading enable
        isMore={false} // More options Enable
        isExport={true} // export options enable
        isUpload={true} // upload options enable
        isAdd={false} // add option enable
        isDateFilter={false} // date filter enable
        isSearch={true} // seacrh enable
        pagination={pagination}
        setPagination={setPagination}
      />
    </DashboardLayout>
  );
};

export default History;
